import React, { ReactElement } from 'react';
import { Box, Typography } from '@mui/material';

export interface TicketTypeBadgeProps {
  label: string;
}

export const TicketTypeBadge = ({ label }: TicketTypeBadgeProps): ReactElement => (
  <Box
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      backgroundColor: '#f0f0f0',
      borderRadius: '9999px',
      px: '9px',
      py: '4px',
      flexShrink: 0,
    }}
  >
    <Typography
      sx={{
        fontFamily: 'Poppins, sans-serif',
        fontSize: '12px',
        fontWeight: 600,
        lineHeight: '18px',
        color: '#383838',
        textTransform: 'uppercase',
        letterSpacing: 0,
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </Typography>
  </Box>
);
